const StockTagManage = () =>
  import('@/views/main/helper/stockTagManage/stockTagManage.vue')
export default {
  path: '/main/helper/stockTagManage',
  name: 'StockTagManage',
  component: StockTagManage
}
